export default __webpack_public_path__ + "static/media/rust.153b32b2.png";